import axios from "@/modules/shared/AxiosInterceptor"
import { IApiKeys } from "@/types/credentials.types"
import { AxiosResponse } from "axios"

export async function postCredentials(keyName: string) {
  return axios
    .post("/credentials", { keyName })
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}

export async function getCredentials(): Promise<AxiosResponse<IApiKeys[]>> {
  return axios
    .get("/credentials")
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}

export async function deleteCredentials(id: string): Promise<AxiosResponse<{ id: string }>> {
  return axios
    .delete(`/credentials/${id}`)
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}
